import { useEffect, useState } from "react";
import { DropdownMenu } from "../basic/DropdownMenu/DropdownMenu";
import { dropdownList } from "./dropdownInfo";
import styles from "./Header.module.scss";
import { SearchInput } from "./SearchInput/SearchInput";
import { MobileSearchInput } from "./MobileSearchInput/MobileSearchInput";
import { Sidebar } from "./Sidebar/Sidebar";
import { TrustpilotBanner } from "../TrustpilotBanner/TrustpilotBanner";
import { useLocation } from "react-router-dom";
import ReactGA from 'react-ga';

const Header = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showMobileSearchInput, setShowMobileSearchInput] = useState(false);
  const location = useLocation();

  useEffect(()=>{
    ReactGA.pageview(location.pathname);
  }, [location.pathname])

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerWrapper}>
        <header className={`${styles.header} container`}>
          <a
            href="/"
            className={`${styles.brandLogo} overflow-hidden`}
            title="New Reg Private Number Plates"
          >
            <h2 className="mt-5">Number Plates</h2>
          </a>
          <div style={{ display: "flex" }}>
            <div className={`${styles.dropdownWrapper} `}>
              {dropdownList.map((dropdownInfo) => {
                return (
                  <DropdownMenu
                    {...dropdownInfo}
                    key={dropdownInfo.text}
                  ></DropdownMenu>
                );
              })}
            </div>
            <div className={`${styles.searchWrapper}`}>
              <SearchInput className={`${styles.searchInput}`}></SearchInput>
              <i
                className={`material-icons cursor-pointer ${styles.icon}`}
                aria-hidden="true"
                data-icon="search"
                onClick={() => setShowMobileSearchInput(!showMobileSearchInput)}
              ></i>
            </div>
            <a
              href="/users"
              aria-label="Search New Reg"
              className={styles.userIcon}
            >
              <i
                className={`material-icons ${styles.icon}`}
                aria-hidden="true"
                data-icon="account_circle"
              ></i>
            </a>
            <span
              className={`items-center content-center h-full cursor-pointer ${styles.menu}`}
            >
              <i
                className={`material-icons ${styles.icon}`}
                aria-hidden="true"
                data-icon="menu"
                onClick={() => {
                  setShowSidebar(true);
                }}
              ></i>
            </span>
            <Sidebar
              isShow={showSidebar}
              close={() => {
                setShowSidebar(false);
              }}
            ></Sidebar>
          </div>
        </header>
      </div>
      <MobileSearchInput
        className={`${styles.mobileSearchInput} ${
          showMobileSearchInput ? "show" : ""
        } !fixed`}
        isShow={showMobileSearchInput}
      ></MobileSearchInput>
      <TrustpilotBanner className="-z-10"></TrustpilotBanner>
    </div>
  );
};

export { Header, Header as default };
